<template>
  <el-button
    type="text"
    size="small"
    :class="resolvedTypeClass"
    :disabled="disabled"
    :icon="resolvedIcon"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    {{ label }}
  </el-button>
</template>

<script lang="ts">
import Vue from 'vue';

const ICON_BY_LABEL: Record<string, string> = {
  查看: 'el-icon-view',
  编辑: 'el-icon-edit',
  删除: 'el-icon-delete',
  下载: 'el-icon-download',
};

export default Vue.extend({
  name: 'ActionBtn',
  inheritAttrs: false,
  props: {
    label: { type: String, required: true },
    type: { type: String, default: 'primary' },
    icon: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    resolvedIcon(): string {
      return this.icon || ICON_BY_LABEL[this.label] || '';
    },
    resolvedTypeClass(): string {
      return `action-btn--${this.type || 'primary'}`;
    },
  },
});
</script>

<style scoped>
.action-btn--danger {
  color: #f56c6c;
}
.action-btn--warning {
  color: #e6a23c;
}
.action-btn--success {
  color: #67c23a;
}
.action-btn--info {
  color: #909399;
}
</style>
